import { useState } from 'react'

const usePendingProposals = (handleMatchProposalConfirm) => {
  const [pendingProposals, setPendingProposals] = useState(new Set())

  const handleMatchProposalConfirmWrapper = async (
    opponentId,
    proposedTime,
    leagueId,
    expiresAt,
    notes,
    isDirectProposal,
  ) => {
    const proposalKey = `${opponentId}-${proposedTime}`

    setPendingProposals((prev) => new Set(prev).add(proposalKey))

    try {
      await handleMatchProposalConfirm(
        opponentId,
        proposedTime,
        leagueId,
        expiresAt,
        notes,
        isDirectProposal,
      )
      setPendingProposals((prev) => {
        const newSet = new Set(prev)
        newSet.delete(proposalKey)
        return newSet
      })
    } catch (error) {
      setPendingProposals((prev) => {
        const newSet = new Set(prev)
        newSet.delete(proposalKey)
        return newSet
      })
      throw error
    }
  }

  return { pendingProposals, handleMatchProposalConfirmWrapper }
}

export default usePendingProposals
